import styled from 'styled-components'

export const ModalBody = styled.div`
  padding: 18px;
`
export const Title = styled.div`
  font-size: 32px;
  text-align: center;
  color: palevioletred;
  margin: 8px;
`
export const Body = styled.div`
  font-size: 18px;
  text-align: center;
  margin: 8px;
`
export const Footer = styled.div`
  text-align: end;
  margin: 8px 8px 0 8px;
`
